export const brandReq = (t) => t("brandReq")
export const brandTrans = (t) => t("brand")
export const bus = (t) => t("bus")
export const busCreatePage = (t) => t("busCreatePage")
export const busCreatedTrans = (t) => t("busCreated")
export const busEditPage = (t) => t("busEditPage")
export const busList = (t) => t("busList")
export const busStation = (t) => t("busStation")
export const busesOnRoute = (t) => t("busesOnRoute")
export const busesTrans = (t) => t("buses")
export const circulationCardTrans = (t) => t("circulationCard")
export const clear = (t) => t("clear")
export const createBusTrans = (t) => t("createBus")
export const createDriverButton = (t) => t("createDriver")
export const createNewBus = (t) => t("createNewBus")
export const createNewDriver = (t) => t("createNewDriver")
export const deleteBus = (t) => t("deleteBus")
export const deleteBusMessage = (t) => t("deleteBusMessage")
export const deleteBusesMessage = (t) => t("deleteBusesMessage")
export const deleteDriver = (t) => t("deleteDriver")
export const deleteDriverMessage = (t) => t("deleteDriverMessage")
export const deleteDriversMessage = (t) => t("deleteDriversMessage")
export const deleteTrans = (t) => t("delete")
export const descriptionTrans = (t) => t("description")
export const disabled= (t) => t("disabled")
export const dni = (t) => t("dni")
export const documentNumberReq = (t) => t("documentNumberRequired")
export const driverCreatePage = (t) => t("driverCreatePage")
export const driverCreatedBar = (t) => t("driverCreated")
export const driverEditPage = (t) => t("editDriver")
export const driverList = (t) => t("driverList")
export const driverTrans = (t) => t("driver")
export const driversTrans = (t) => t("drivers")
export const editBus = (t) => t("editBus")
export const editDriver = (t) => t("editDriver")
export const editTrans = (t) => t("edit")
export const enableDriver = (t) => t("enableDriver")
export const enabled = (t) => t("enabled")
export const errorUpdatingDataBar = (t) => t("errorUpdatingData")
export const hintDNI = (t) => t("documentNumberHint")
export const hintDigits = (t) => t("onlyDigits")
export const hintLetters = (t) => t("onlyLetters")
export const hintPhone = (t) => t("phoneNumberHint")
export const historicalReport = (t) => t("historicalReport")
export const dateReq = (t) => t("dateRequired")
export const hintInputStringMaxSize = (t) => t("inputStringMaxSize")
export const insuranceTrans = (t) => t("insurance")
export const language = (t) => t("language")
export const lastNameReq = (t) => t("lastNameRequired")
export const lastNameTrans = (t) => t("lastName")
export const licenseExpDateTrans = (t) => t("licenseExpDate")
export const list = (t) => t("list")
export const liveTracking= (t) => t("liveTracking")
export const loginTrans = (t) => t("login")
export const mapTrans = (t) => t("map")
export const modelReq = (t) => t("modelReq")
export const modelTrans = (t) => t("model")
export const nameReq = (t) => t("nameRequired")
export const nameTrans = (t) => t("name")
export const newBus = (t) => t("newBus")
export const newDriver = (t) => t("newDriver")
export const noResults = (t) => t("noResults")
export const othersTrans = (t) => t("others")
export const ownerLastNameTrans = (t) => t("ownerLastName")
export const ownerNameTrans = (t) => t("ownerName")
export const phone = (t) => t("phone")
export const phoneNumberReq = (t) => t("phoneNumberRequired")
export const plateReq = (t) => t("plateRequired")
export const plateTrans = (t) => t("plate")
export const registeredDriverBar = (t) => t("registeredDriver")
export const registeredBusTrans = (t) => t("registeredBus")
export const reportByBus = (t) => t("reportByBus")
export const reportByDay = (t) => t("reportByDay")
export const report = (t) => t("report")
export const reports = (t) => t("reports")
export const role = (t) => t("role")
export const roleReq = (t) => t("roleRequired")
export const routeTrans = (t) => t("route")
export const routesTrans = (t) => t("routes")
export const saveChanges = (t) => t("saveChanges")
export const saveChangesButton = (t) => t("saveChanges")
export const search = (t) => t("search")
export const searchByBusOptions = (t) => t("searchByBusOptions")
export const searchByDriverOptions = (t) => t("searchByDriverOptions")
export const selectPlateReq = (t) => t("selectPlateRequired")
export const selectRouteReq = (t) => t("selectRouteRequired")
export const settings = (t) => t("settings")
export const unknown = (t) => t("unknown")
export const updatedBusTrans = (t) => t("updatedBus")
export const updatedDriverBar = (t) => t("updatedDriver")
export const yearProduction = (t) => t("yearProduction")
export const yearProdReq = (t) => t("yearProductionRequired")
export const labelAllFiles = (t) => t("allFiles")
export const labelSelectRoute = (t) => t("labelSelectRoute")
export const labelHour = (t) => t("labelHour")
export const labelMonth = (t) => t("labelMonth")
export const labelPlate = (t) => t("labelPlate")
export const labelStatus = (t) => t("labelStatus")
export const labelLastGeneratedFile = (t) => t("lastGeneratedFile")
export const labelRoute = (t) => t("labelRoute")
export const labelCancel = (t) => t("labelCancel")
export const requestDataDeletion = (t) => t("requestDataDeletion")
export const login = (t) => t("login")
export const removeData = (t) => t("removeData")
export const userDataRemove = (t) => t("userDataRemove")
export const send = (t) => t("send")
export const departures = (t) => t("departures")
export const disable = (t) => t("disable")
export const exportDrivers = (t) => t("exportDrivers")
export const labelUpdateDrivers = (t) => t("updateDrivers")
export const editRoute = (t) => t("editRoute")
export const labelAnnouncement = (t) => t("announcement")
export const labelMessage = (t) => t("message")
export const labelStations = (t) => t("stations")
export const labelNewStation = (t) => t("newStation")
export const stationCreatePage = (t) => t("stationCreatePage")
export const stationEditPage = (t) => t("stationEditPage")
export const labelStation = (t) => t("station")
export const labelEditStation = (t) => t("editStation")
export const labelExpirationDate = (t) => t("expirationDate")
export const labelUnitsPerColumn = (t) => t("unitsPerColumn")
export const labelEdit = (t) => t("edit")

// login messages
export const labelPassword = (t) => t("password")
export const labelEmail = (t) => t("email")
export const signIn = (t) => t("signIn")
export const msgInvalidPass = (t) => t("msgInvalidPass")
export const msgUserNotFound = (t) => t("msgUserNotFound")
export const msgUserTempDisabled = (t) => t("msgUserTempDisabled")
export const msgErrorFound = (t) => t("msgErrorFound")

// reports messages
export const datePicker = (t) => t("date")
export const labelBusReport = (t) => t("busReport")
export const labelDayReport = (t) => t("dayReport")
export const labelIncidents = (t) => t("incidents")
export const labelNoIncidents = (t) => t("noIncidents")
export const labelShowIncidents = (t) => t("showIncidents")
export const labelDownloadControlReport = (t) => t("downloadControlReport")
export const labelDownloadReportFull = (t) => t("downloadReportFull")
export const lapsTrs = (t) => t("laps")
export const searchBtn = (t) => t("searchBtn")
export const dayLabel = (t) => t("day")
export const msgReportDay = (t) => t("msgReportDay")
export const msgReportMonth = (t) => t("msgReportMonth")
export const downloadBtn = (t) => t("downloadBtn")

// routes messages
export const labelDeleteRoute = (t) => t("deleteRoute")
export const labelLaps = (t) => t("laps")
export const labelNewRoute = (t) => t("newRoute")
export const labelNo = (t) => t("no")
export const labelRoutes = (t) => t("routes")
export const labelShowTrack = (t) => t("showTrack")
export const labelUploadRoutes = (t) => t("uploadRoutes")
export const labelYes = (t) => t("yes")
export const msgDeleteRoute = (t) => t("msgDeleteRoute")
export const routeCreatePage = (t) => t("routeCreatePage")
export const titleRouteNotSelected = (t) => t("titleRouteNotSelected")
export const msgSelectRoute = (t) => t("msgSelectRoute")
export const labelEnabled = (t) => t("enabled")
export const labelDemo = (t) => t("demo")
export const labelCode = (t) => t("code")
export const labelGraceMinutes = (t) => t("graceMinutes")
export const labelGraceMinutesPerLap = (t) => t("graceMinutesPerLap")
export const labelStationLocation = (t) => t("stationLocation")
export const labelName = (t) => t("name")
export const labelPenalty = (t) => t("penalty")
export const labelLatitude = (t) => t("latitude")
export const labelLongitude = (t) => t("longitude")
export const labelPenalized = (t) => t("penalized")
export const labelVisible = (t) => t("visible")
export const labelDelete = (t) => t("delete")
export const labelAdd = (t) => t("add")
export const labelRestore = (t) => t("restore")
export const labelDay = (t) => t("day")
export const labelLap = (t) => t("lap")
export const labelRange = (t) => t("range")
export const labelStart = (t) => t("start")
export const labelEnd = (t) => t("end")
export const labelControlPoints = (t) => t("controlPoints")
export const labelDetails = (t) => t("details")
export const labelFrequency = (t) => t("frequency")
export const labelUploadPath = (t) => t("uploadPath")
export const greetings = (t) => t("greetings")
export const messageInformative = (t) => t("messageInformative")
export const thanks = (t) => t("thanks")
export const contactMessage = (t) => t("contactMessage")
export const labelContinue = (t) => t("labelContinue")
export const labelAutomatedControl = (t) => t("automatedControl")
export const labelDownloadPath = (t) => t("downloadPath")
export const labelControlMode = (t) => t("controlMode")

// Lap incidents
export const turnOffGps = (t) => t("turnOffGps")
export const turnOffInternet = (t) => t("turnOffInternet")
export const turnOffAutoTime = (t) => t("turnOffAutoTime")
export const turnOnGps = (t) => t("turnOnGps")
export const turnOnInternet = (t) => t("turnOnInternet")
export const turnOnAutoTime = (t) => t("turnOnAutoTime")
export const unknownIncident = (t) => t("unknownIncident")

// Form suggestions
export const routeCodeReq = (t) => t("routeCodeRequired")
export const routeCodeHint = (t) => t("routeCodeHint")
export const routeNameReq = (t) => t("routeNameRequired")
export const routeVariantReq = (t) => t("routeVariantRequired")
export const numberReq = (t) => t("numberRequired")
export const positiveNumberReq = (t) => t("positiveNumberRequired")
export const onlyAlphanumeric = (t) => t("onlyAlphanumeric")
export const pointNameReq = (t) => t("pointNameRequired")
export const latitudeHint = (t) => t("latitudeHint")
export const longitudeHint = (t) => t("longitudeHint")
export const graceMinutesLimit = (t) => t("graceMinutesLimit")
export const pointCodeReq = (t) => t("pointCodeRequired")
export const pointCodeHint = (t) => t("pointCodeHint")
export const departurePointHint = (t) => t("departurePointHint")
export const timeReq = (t) => t("timeReq")
export const startTimeGreaterHint = (t) => t("startTimeGreaterHint")
export const startTimeLessHint = (t) => t("startTimeLessHint")
export const endTimeGreaterHint = (t) => t("endTimeGreaterHint")
export const selectControlModeReq = (t) => t("selectControlModeRequired")
export const messageReq = (t) => t("messageRequired")
export const stationNameReq = (t) => t("stationNameReq")
export const stationCodeReq = (t) => t("stationCodeReq")
export const onlyNumber = (t) => t("onlyNumber")

// Snackbar messages
export const registeredRouteInfoBar = (t) => t("registeredRouteInfo")
export const routeInfoCreatedBar = (t) => t("routeInfoCreated")
export const updatedRouteInfoBar = (t) => t("updatedRouteInfo")
export const pointsCreatedBar = (t) => t("pointsCreated")
export const pointsCreationFailedBar = (t) => t("pointsCreationFailed")
export const updatedPointsBar = (t) => t("updatedPoints")
export const errorUpdatingPointsBar = (t) => t("errorUpdatingPoints")
export const controlTimesCreatedBar = (t) => t("controlTimesCreated")
export const controlTimesCreationFailedBar = (t) => t("controlTimesCreationFailed")
export const updatedControlTimesBar = (t) => t("updatedControlTimes")
export const errorUpdatingControlTimesBar = (t) => t("errorUpdatingControlTimes")
export const noChangesBar = (t) => t("noChanges")
export const departureTimesCreatedBar = (t) => t("departureTimesCreated")
export const departureTimesCreationFailedBar = (t) => t("departureTimesCreationFailed")
export const updatedDepartureTimesBar = (t) => t("updatedDepartureTimes")
export const errorUpdatingDepartureTimesBar = (t) => t("errorUpdatingDepartureTimes")
export const routeCreatedBar = (t) => t("routeCreated")
export const routeCreationFailedBar = (t) => t("routeCreationFailed")
export const pathCreatedBar = (t) => t("pathCreated")
export const pathCreationFailedBar = (t) => t("pathCreationFailed")
export const updatedDriversBar = (t) => t("updatedDrivers")
export const updatedDriversFailedBar = (t) => t("updatedDriversFailed")
export const errorGetPathFile = (t) => t("errorGetPathFile")
export const pathFileCreationFailedBar = (t) => t("pathFileCreationFailed")
export const announcementCreatedBar = (t) => t("announcementCreated")
export const announcementCreationFailedBar = (t) => t("announcementCreationFailed")
export const stationCreatedBar = (t) => t("stationCreated")
export const registeredStationBar = (t) => t("RegisteredStation")
export const updatedStationBar = (t) => t("updatedStation")
export const errorUpdatingStationBar = (t) => t("errorUpdatingStation")

// Schedule
export const scheduleConfiguration = (t) => t("scheduleConfiguration")
export const configurationLabel = (t) => t("configuration")
export const newScheduleLabel = (t) => t("newSchedule")
export const scheduleCreatePage = (t) => t("scheduleCreatePage")
export const labelGroups = (t) => t("groups")
export const labelBus = (t) => t("bus")
export const selectGroupReq = (t) => t("selectGroupRequired")
export const ScheduleSettingsCreatedBar = (t) => t("scheduleSettingsCreated")
export const registeredScheduleSettings = (t) => t("registeredScheduleSettings")